var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "3 3 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33398 7.72917C9.33398 7.33056 8.99398 7 8.58398 7H5.33398C4.73398 7 4.33398 7.48611 4.33398 7.97222V11.8611C4.33398 12.3472 4.73398 12.8333 5.33398 12.8333H8.33398C8.93398 12.8333 9.33398 12.3472 9.33398 11.8611V10.6458C9.33398 10.2472 8.99398 9.91667 8.58398 9.91667C8.17398 9.91667 7.83398 10.2472 7.83398 10.6458V11.375H5.83398V8.45833H8.58398C8.99398 8.45833 9.33398 8.12778 9.33398 7.72917ZM11.0005 7.00004C11.456 7.00004 11.8338 7.3306 11.8338 7.72921V12.1042C11.8338 12.5028 11.456 12.8334 11.0005 12.8334C10.5449 12.8334 10.1672 12.5028 10.1672 12.1042V7.72921C10.1672 7.3306 10.5449 7.00004 11.0005 7.00004ZM16.9727 7.00004C17.3523 7.00004 17.6672 7.3306 17.6672 7.72921C17.6672 8.12782 17.3523 8.45837 16.9727 8.45837H14.8894V9.4306H16.0468C16.4264 9.4306 16.7412 9.76115 16.7412 10.1598C16.7412 10.5584 16.4264 10.8889 16.0468 10.8889H14.8894V12.1042C14.8894 12.5028 14.5746 12.8334 14.1949 12.8334C13.8153 12.8334 13.5005 12.5028 13.5005 12.1042V7.97226C13.5005 7.43754 13.9172 7.00004 14.4264 7.00004H16.9727Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.4c585a7e1566792d4dd5de6cb7f397f5.svg";
export { ForwardRef as ReactComponent };